import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';

import {KeHoach} from '../../../models/kehoach/kehoach';
import {LoaiKeHoach} from '../../../models/danhmuc/loaikehoach';
import {KeHoachService} from '../../../service/kehoach/service-kehoach';
import {KeHoachFileService} from '../../../service/kehoach/service-kehoachfile';
import {LoaiKeHoachService} from '../../../service/danhmuc/service-loaikehoach';


import {NavItemService} from '../../../service/staff/service-navitem';
import {Sessioncommand} from '../../../global/sessioncommand';
import {PermissionService} from '../../../service/security/service-permission';
import {Permission} from '../../../models/security/permission';
import {PermissionsComponent} from '../role/permission.component';
import {EditPermissionComponent} from './edit.component';
import {EditPermissionCodeComponent} from './editdetail.component';
import {PermissionCodeService} from '../../../service/security/service-permissioncode';
import {AssignRolePermissionComponent} from './assign.component';
import {AssignMenuPermissionComponent} from './assignmenu.component';


@Component({
  templateUrl: './view.component.html',
  encapsulation: ViewEncapsulation.None
})
export class FunctionComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public isRefresh: boolean = false;
  public dataList: Permission[];
  public submitValidate = false;

  constructor( public permissionService: PermissionService,
               public permissionCodeService: PermissionCodeService,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public commandUtil: CommandUtil,
               public navItemService: NavItemService
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.search();

  }

  public deleteModal(id: number): void {

      const modal = this.bsModalService.show(ConfirmDialogComponent);
      (<ConfirmDialogComponent>modal.content).showConfirmationModal(
        language.message,
        language.confirm_delete_question,
        language.yes,
        language.no
      );
      (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
        if (result === true) {
          this.deleteItem(id);
        }
      });

  }
  public deleteDetailModal(id: number): void {

    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteDetailModal(id);
      }
    });

  }
  public edit(id: number): void {
    const modalEdit = this.bsModalService.show(EditPermissionComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditPermissionComponent>modalEdit.content).edit(
      id

    );
    (<EditPermissionComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
          this.search();

      }
    });
  }
  public editDetails(id: number, funcGroupId: number): void {
    const modalEdit = this.bsModalService.show(EditPermissionCodeComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditPermissionCodeComponent>modalEdit.content).edit(
      id, funcGroupId

    );
    (<EditPermissionCodeComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  public assign(id: number): void {
    const modalEdit = this.bsModalService.show(AssignRolePermissionComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<AssignRolePermissionComponent>modalEdit.content).edit(
      id

    );
    (<AssignRolePermissionComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public assignMenu(code: string): void {
    const modalEdit = this.bsModalService.show(AssignMenuPermissionComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<AssignMenuPermissionComponent>modalEdit.content).edit(
      code

    );
    (<AssignMenuPermissionComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  search()
  {    this.permissionService.getAll().subscribe(dataList => this.dataList = dataList);
  }

  deleteItem(id: number)
  {
    this.permissionService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  deleteDetailsItem(id: number)
  {
    this.permissionCodeService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

}

